import React, { useEffect, useRef, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import { Link } from 'react-router-dom';
import { all_routes } from '../../../../core/data/routes/all_routes';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import VideoModal from '../../../../core/hooks/video-modal';
import StickyBox from 'react-sticky-box';
import { db } from '../../../../firebase';
import { getDocs, collection, limit, query } from 'firebase/firestore';
import { Button, Col, Row, Spin } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import { getAuth } from 'firebase/auth';


const ServiceDetails1 = () => {
  const routes = all_routes;
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const sliderRef1 = useRef(null);
  const sliderRef2 = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const videoUrl = 'https://www.youtube.com/watch?v=xugIds3E5UI&list=RDxugIds3E5UI&start_radio=1';
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [open, setOpen] = React.useState(false);

  const two = {
    dots: false,
    autoplay: false,
    slidesToShow: 6,
    speed: 500,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 776,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
  const settings1 = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: nav2 || undefined, // Link to the second slider
    ref: (slider: any) => (sliderRef1.current = slider), // Assign the slider ref
  };

  const settings2 = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    asNavFor: nav1 || undefined, // Link to the first slider
    ref: (slider: any) => (sliderRef2.current = slider), // Assign the slider ref
  };

  //booking Fetch Data
  const location = useLocation();
  const navigate = useNavigate();
  const category = location.state?.category;

  if (!category) {
    return <p>Category data not found!</p>;
  }

  const handleBookService = () => {

    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      // User is authenticated, navigate to service details
      // console.log("tttttt")
      navigate(routes.booking2, { state: { category } });
    } else {
      // User is not authenticated, redirect to login page
      navigate(routes.login);
    }

    // console.log("Navigating to booking2");
    // navigate(routes.booking2, { state: { category } });
  };

  // Navigate to Service Details Page with Category Data
  // const handleBookNow = (category) => {
  //   const auth = getAuth();
  //   const user = auth.currentUser;

  //   if (user) {
  //     // User is authenticated, navigate to service details
  //     navigate(routes.serviceDetails1, { state: { category } });
  //   } else {
  //     // User is not authenticated, redirect to login page
  //     navigate(routes.login);
  //   }
  // };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <BreadCrumb
        title="Categories Details"
        item1="Categories"
        item2="Categories Details"
      />
      <div className="page-wrapper">
        <div className="content"
          style={{
            backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div className="card border-0">
                  <div
                    className="card-body"
                    style={{
                      background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                      borderRadius: "10px", // Optional: adjust the border radius
                      backdropFilter: "blur(10px)", // Applies the blur effect
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                      padding: "20px", // Optional: adjust padding for content spacing
                      border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                    }}
                  >
                    <div className="service-head mb-2">
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="mb-2 text-linear-primary" style={{color: "white"}}>{category.title}</h3>
                        <span className="badge badge-purple-transparent mb-2">
                          <i className="ti ti-calendar-check me-1" />
                          6000+ Bookings
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                        <div className="d-flex align-items-center flex-wrap">
                          <p className="me-3 mb-2" style={{color: "white"}}>
                            <i className="ti ti-map-pin me-2" />
                            21/1/2 Darmashoka Mawatha Kandy, Sri Lanka{' '}
                            <Link
                              to="#"
                              className="link-primary text-decoration-underline"
                            >
                              View Location
                            </Link>
                          </p>
                          <p className="mb-2" style={{color: "white"}}>
                            <i className="ti ti-star-filled text-warning me-2" />
                            <span style={{color: "white"}}>4.9&nbsp;</span>(255
                            reviews)
                          </p>
                        </div>
                        <div className="d-flex align-items-center flex-wrap">
                          <Link to="javscript:void(0);" className="me-3 mb-2" style={{color: "white"}}>
                            <i className="ti ti-eye me-2"  style={{color: "blue"}}/>
                            3050 Views
                          </Link>
                          <Link to="javscript:void(0);" className="me-3 mb-2" style={{color: "white"}}>
                            <i className="ti ti-heart me-2"  style={{color: "red"}}/>
                            Add to Wishlist
                          </Link>
                          <Link to="javscript:void(0);" className="me-3 mb-2" style={{color: "white"}}>
                            <i className="ti ti-share me-2"  style={{color: "purple"}}/>
                            Share Now
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* Slider */}
                    <div className="service-wrap mb-4">
                      <div className="slider-wrap">
                        <Slider
                          {...settings1}
                          className="owl-carousel reactslick service-carousel nav-center mb-3"
                        >

                          <div className="service-img">
                            <img
                              // src="assets/img/services/service-slider-04.jpg"
                              src={category.category_view_icon || "placeholder-image-path.jpg"}
                              className="img-fluid"
                              alt="Slider Img"
                              width={800}
                            // height={500}
                            />
                          </div>
                        </Slider>
                      </div>

                      <Row>
                        <Col span={6}><img
                          src={category.album[0].link || "https://placehold.co/184x252.png"}
                          alt="Service Preview 1"
                          className="w-[184px] h-[252px] object-cover rounded-lg shadow-md"
                        /></Col>

                        <Col span={6}>
                          <img
                            src={category.album[1].link || "https://placehold.co/184x120.png"}
                            alt="Service Preview 2"
                            className="w-[184px] h-[120px] object-cover rounded-lg shadow-md"
                            style={{ padding: '5px' }}
                          />
                          <img
                            src={category.album[2].link || "https://placehold.co/184x120.png"}
                            alt="Service Preview 3"
                            className="w-[184px] h-[120px] object-cover rounded-lg shadow-md"
                            style={{ marginTop: '5px' }}
                          />
                        </Col>


                        <Col span={6}><img
                          src={category.album[3].link || "https://placehold.co/184x120.png"}
                          alt="Service Preview 4"
                          className="w-[184px] h-[120px] object-cover rounded-lg shadow-md"
                          style={{ padding: '5px' }}
                        />
                          <img
                            src={category.album[4].link || "https://placehold.co/184x120.png"}
                            alt="Service Preview 5"
                            className="w-[184px] h-[120px] object-cover rounded-lg shadow-md"
                            style={{ marginTop: '5px' }}
                          /></Col>

                        <Col span={6}><img
                          src={category.album[5].link || "https://placehold.co/184x252.png"}
                          alt="Service Preview 6"
                          className="w-[184px] h-[252px] object-cover rounded-lg shadow-md mx-auto"
                        /></Col>
                      </Row>


                    </div>
                    {/* /Slider */}
                    <div className="accordion service-accordion"
                    style={{
                      background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                      borderRadius: "10px", // Optional: adjust the border radius
                      backdropFilter: "blur(10px)", // Applies the blur effect
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                      padding: "20px", // Optional: adjust padding for content spacing
                      border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                    }}>
                      <div className="accordion-item mb-4"
                      style={{
                        background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                        borderRadius: "10px", // Optional: adjust the border radius
                        backdropFilter: "blur(10px)", // Applies the blur effect
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                        padding: "20px", // Optional: adjust padding for content spacing
                        border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                      }}>
                        <h2 className="accordion-header" style={{color: "white"}}>
                          <button
                            className="accordion-button p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#overview"
                            aria-expanded="false"
                            style={{color: "white", backgroundColor: "black"}}
                          >
                            About Service
                          </button>
                        </h2>
                        <div
                          id="overview"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body border-0 p-0 pt-3">
                            <div className="more-text">
                              <p style={{color: "white"}}>
                                {category.about}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-0 mb-xl-0 mb-4">
                  <div className="card-body"
                  style={{
                    background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                    borderRadius: "10px", // Optional: adjust the border radius
                    backdropFilter: "blur(10px)", // Applies the blur effect
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                    padding: "20px", // Optional: adjust padding for content spacing
                    border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                  }}>
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <h4 className="mb-3" style={{color: "white"}}>Reviews (45)</h4>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#add-review"
                        className="btn btn-dark btn-sm mb-3"
                      >
                        Write a Review
                      </Link>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-5">
                        <div className="rating-item bg-light-500 text-center mb-3">
                          <h5 className="mb-3">
                            Customer Reviews &amp; Ratings
                          </h5>
                          <div className="d-inline-flex align-items-center justify-content-center">
                            <i className="ti ti-star-filled text-warning me-1" />
                            <i className="ti ti-star-filled text-warning me-1" />
                            <i className="ti ti-star-filled text-warning me-1" />
                            <i className="ti ti-star-filled text-warning me-1" />
                            <i className="ti ti-star-filled text-warning" />
                          </div>
                          <p className="mb-3">(4.9 out of 5.0)</p>
                          <p className="text-gray-9">Based On 2,459 Reviews</p>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div className="rating-progress mb-3">
                          <div className="d-flex align-items-center mb-2">
                            <p className="me-2 text-nowrap mb-0" style={{color: "white"}}>
                              5 Star Ratings
                            </p>
                            <div
                              className="progress w-100"
                              role="progressbar"
                              aria-valuenow={90}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-warning"
                                style={{ width: '90%' }}
                              />
                            </div>
                            <p className="progress-count ms-2" style={{color: "white"}}>2,547</p>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p className="me-2 text-nowrap mb-0" style={{color: "white"}}>
                              4 Star Ratings
                            </p>
                            <div
                              className="progress mb-0 w-100"
                              role="progressbar"
                              aria-valuenow={80}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-warning"
                                style={{ width: '80%' }}
                              />
                            </div>
                            <p className="progress-count ms-2" style={{color: "white"}}>1,245</p>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p className="me-2 text-nowrap mb-0" style={{color: "white"}}>
                              3 Star Ratings
                            </p>
                            <div
                              className="progress mb-0 w-100"
                              role="progressbar"
                              aria-valuenow={70}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-warning"
                                style={{ width: '70%' }}
                              />
                            </div>
                            <p className="progress-count ms-2" style={{color: "white"}}>600</p>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p className="me-2 text-nowrap mb-0" style={{color: "white"}}>
                              2 Star Ratings
                            </p>
                            <div
                              className="progress mb-0 w-100"
                              role="progressbar"
                              aria-valuenow={90}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-warning"
                                style={{ width: '60%' }}
                              />
                            </div>
                            <p className="progress-count ms-2" style={{color: "white"}}>560</p>
                          </div>
                          <div className="d-flex align-items-center">
                            <p className="me-2 text-nowrap mb-0" style={{color: "white"}}>
                              1 Star Ratings
                            </p>
                            <div
                              className="progress mb-0 w-100"
                              role="progressbar"
                              aria-valuenow={40}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-warning"
                                style={{ width: '40%' }}
                              />
                            </div>
                            <p className="progress-count ms-2" style={{color: "white"}}>400</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card review-item mb-3">
                      <div className="card-body p-3">
                        <div className="review-info">
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="d-flex align-items-center mb-2">
                              <span className="avatar avatar-lg me-2 flex-shrink-0">
                                <ImageWithBasePath
                                  src="assets/img/profiles/avatar-03.jpg"
                                  className="rounded-circle"
                                  alt="img"
                                />
                              </span>
                              <div>
                                <h6 className="fs-16 fw-medium">Don Rosales</h6>
                                <div className="d-flex align-items-center flex-wrap date-info">
                                  <p className="fs-14 mb-0">2 days ago</p>
                                  <p className="fs-14 mb-0">Great Service!</p>
                                </div>
                              </div>
                            </div>
                            <span className="badge bg-danger d-inline-flex align-items-center mb-2">
                              <i className="ti ti-star-filled me-1" />1
                            </span>
                          </div>
                          <p className="mb-2">
                            The quality of work was exceptional, and they left
                            the site clean and tidy. I was impressed by their
                            attention to detail and commitment to safety
                            standards. Highly recommend their services!
                          </p>
                          <div className="d-flex align-items-center justify-content-between flex-wrap like-info">
                            <div className="d-inline-flex align-items-center flex-wrap">
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-up me-2" />
                                Reply
                              </Link>
                            </div>
                            <div className="d-inline-flex align-items-center">
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-up me-2" />
                                15
                              </Link>
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-down me-2" />1
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card review-item mb-3">
                      <div className="card-body p-3">
                        <div className="review-info">
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="d-flex align-items-center mb-2">
                              <span className="avatar avatar-lg me-2 flex-shrink-0">
                                <ImageWithBasePath
                                  src="assets/img/profiles/avatar-04.jpg"
                                  className="rounded-circle"
                                  alt="img"
                                />
                              </span>
                              <div>
                                <h6 className="fs-16 fw-medium">Paul Bronk</h6>
                                <div className="d-flex align-items-center flex-wrap date-info">
                                  <p className="fs-14 mb-0">2 days ago</p>
                                  <p className="fs-14 mb-0">
                                    Reliable and Trustworthy!
                                  </p>
                                </div>
                              </div>
                            </div>
                            <span className="badge bg-success d-inline-flex align-items-center mb-2">
                              <i className="ti ti-star-filled me-1" />1
                            </span>
                          </div>
                          <p className="mb-2">
                            The quality of work was exceptional, and they left
                            the site clean and tidy. I was impressed by their
                            attention to detail and commitment to safety
                            standards. Highly recommend their services!
                          </p>
                          <div className="d-flex align-items-center justify-content-between flex-wrap like-info">
                            <div className="d-inline-flex align-items-center flex-wrap">
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-up me-2" />
                                Reply
                              </Link>
                            </div>
                            <div className="d-inline-flex align-items-center">
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-up me-2" />
                                10
                              </Link>
                              <Link
                                to="#"
                                className="d-inline-flex align-items-center me-2"
                              >
                                <i className="ti ti-thumb-down me-2" />2
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center" style={{color: "white"}}>
                      <Link to="#" className="btn btn-light btn-sm" style={{color: "white"}}>
                        Load More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 theiaStickySidebar">
                <StickyBox>
                  <div className="card border-0">
                    <div className="card-body"
                    style={{
                      background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                      borderRadius: "10px", // Optional: adjust the border radius
                      backdropFilter: "blur(10px)", // Applies the blur effect
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                      padding: "20px", // Optional: adjust padding for content spacing
                      border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                    }}>
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                        <div className="d-flex align-items-center">
                          <div className="mb-3">
                            <p className="fs-14 mb-0" style={{color: "white"}}>Starts From</p>
                            <h4>
                              <span className="display-6 fw-bold" style={{color: "white"}}>
                                ₹ {category.price}
                                {/* {categories.price ? category.price.toFixed(2) : "Price not available"} */}
                              </span>
                              <span className="text-decoration-line-through" style={{color: "white"}}>
                                {' '}
                                ₹ 475
                              </span>
                            </h4>
                          </div>
                        </div>
                        <span className="badge bg-success mb-3 d-inline-flex align-items-center fw-medium">
                          <i className="ti ti-circle-percentage me-1" />
                          50% Offer
                        </span>
                      </div>
                      <div
                        //  to={routes.booking2}
                        onClick={handleBookService}
                        className="btn btn-lg btn-primary w-100 d-flex align-items-center justify-content-center mb-3"
                         style={{color: "white"}}
                      >
                        <i className="ti ti-calendar me-2" style={{color: "white"}} />
                        Book Service
                      </div>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#add-enquiry"
                        className="btn btn-lg btn-outline-light d-flex align-items-center justify-content-center w-100"
                        style={{color: "white"}}
                      >
                        <i className="ti ti-mail me-2"  style={{color: "white"}}/>
                        <p style={{color: "white"}}>Send Enquiry</p>
                      </Link>
                    </div>
                  </div>
                  <div className="card border-0">
                    <div className="card-body"
                    style={{
                      background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                      borderRadius: "10px", // Optional: adjust the border radius
                      backdropFilter: "blur(10px)", // Applies the blur effect
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                      padding: "20px", // Optional: adjust padding for content spacing
                      border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                    }}>
                      <h4 className="mb-3" style={{color: "white"}}>Business Hours</h4>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Monday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Tuesday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Wednesday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Thursday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Friday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Saturday</h6>
                        <p style={{color: "white"}}>9:30 AM - 7:00 PM</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-0">
                        <h6 className="fs-16 fw-medium mb-0" style={{color: "white"}}>Sunday</h6>
                        <p className="text-danger" style={{color: "white"}}>Closed</p>
                      </div>
                    </div>
                  </div>
                  <div className="card border-0">
                    <div className="card-body"
                    style={{
                      background: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                      borderRadius: "10px", // Optional: adjust the border radius
                      backdropFilter: "blur(10px)", // Applies the blur effect
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
                      padding: "20px", // Optional: adjust padding for content spacing
                      border: "1px solid rgba(0, 0, 0, 0.45)", // Optional: adds a border with some transparency
                    }}>
                      <h4 className="mb-3" style={{color: "white"}}>Location</h4>
                      <div className="map-wrap">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4833.489966443573!2d74.98035831641499!3d12.503268100000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba48385f1cae3df%3A0x7c3e9daaddfa4e75!2smahincha.com!5e1!3m2!1sen!2slk!4v1740889399867!5m2!1sen!2slk"
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          className="contact-map"
                        />
                      </div>
                    </div>
                  </div>
                  <Link to="#" className="text-danger fs-14">
                    <i className="ti ti-pennant-filled me-2" />
                    Report Provider
                  </Link>
                </StickyBox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[
          {
            src: '/react/template/assets/img/services/service-slider-02.jpg',
          },
          {
            src: '/react/template/assets/img/services/service-slider-03.jpg',
          },
          {
            src: '/react/template/assets/img/services/service-slider-01.jpg',
          },
          {
            src: '/react/template/assets/img/services/service-slider-04.jpg',
          },
          {
            src: '/react/template/assets/img/services/service-slider-05.jpg',
          },
        ]}
      />
    </>
  );
};

export default ServiceDetails1;
